import { mutationFor } from "@visioni/a3s-client-api/app";
import { deterrenceCommandEndpoint } from "../client-messages/commands";

export const deterrenceCommandMutation = mutationFor(deterrenceCommandEndpoint);
